import { FC, useEffect, useRef } from 'react';
import cx from 'classnames/bind';
import { Navigation, Pagination } from 'swiper';
import { useMediaQuery } from 'react-responsive';

import { Button } from '../Button';
import { Layout } from '../Layout';
import Swiper from '../Swiper/Swiper';
import { Hint } from '../Hint';
import type { IProduct } from '@/types/product';

import styles from './Product.module.scss';

interface ProductProps {
  setStep: (value: number) => void;
  setIsTrainingCompleted: (value: boolean) => void;
  product: IProduct;
}

const config = {
  className: 'swiper-product',
  spaceBetween: 50,
  pagination: {
    clickable: true,
  },
  modules: [Navigation, Pagination],
  allowSlidePrev: false,
};

const cn = cx.bind(styles);

const Product: FC<ProductProps> = ({
  setStep,
  setIsTrainingCompleted,
  product,
}) => {
  const isDesctop = useMediaQuery({ query: '(min-width: 1440px)' });

  useEffect(() => {
    setIsTrainingCompleted(true);
  }, []);

  const next = useRef(null);
  const prev = useRef(null);
  const paginationRef = useRef(null);

  const refs = {
    next,
    prev,
    pagination: paginationRef,
  };

  const nextStep = () => {
    setStep(9);
  };

  return (
    <>
      <div className={cn('background')} />
      <Layout className={cn('container')}>
        {product &&
          (isDesctop ? (
            <div className={cn('wrap')}>
              <div className={cn('wrapper')}>
                <img
                  src={product?.imgUrl}
                  className={cn('img')}
                  alt="Пачка сигарет"
                />
                <div className={cn('content')}>
                  <span className={cn('subtitle')}>{product?.name}</span>
                  <h1 className={cn('title')}>{product?.title}</h1>
                  <ul className={cn('list')}>
                    {product?.characteristics.map(({ imgUrl, title }) => (
                      <li key={title} className={cn('item')}>
                        <img
                          className={cn('icon')}
                          src={imgUrl}
                          alt="Иконка преимущества"
                        />
                        <span className={cn('text')}>{title}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <Hint className={cn('hint')}>
                {product?.description}
                <Button handleClick={nextStep} className={cn('button')}>
                  Дальше
                </Button>
              </Hint>
            </div>
          ) : (
            <div className={cn('wrap')}>
              <div className={cn('left')}>
                <span className={cn('subtitle')}>{product?.name}</span>
                <h1 className={cn('title')}>{product?.title}</h1>
                <img
                  src={product?.imgUrl}
                  className={cn('img')}
                  alt="Пачка сигарет"
                />
              </div>
              <div className={cn('right')}>
                <Swiper {...config} refs={refs}>
                  <p className={cn('description')}>{product?.description}</p>
                  {product?.characteristics.map(({ imgUrl, title }) => (
                    <Hint key={title} className={cn('advantage')}>
                      <img
                        className={cn('icon')}
                        src={imgUrl}
                        alt="Иконка преимущества"
                      />
                      {title}
                    </Hint>
                  ))}
                </Swiper>
                <div className="pagination-product" ref={paginationRef} />
                <button className={cn('hide')} type="button" ref={prev}>
                  Назад
                </button>
                <Button className={cn('next')} ref={next}>
                  Дальше
                </Button>
                <Button handleClick={nextStep} className={cn('next')}>
                  Дальше
                </Button>
              </div>
            </div>
          ))}
      </Layout>
    </>
  );
};

export default Product;
